module.exports = __webpack_public_path__ + "img/Android.df783e5f.jpg";